/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Company Management API
 * API for managing companies and their users
 * OpenAPI spec version: 1.0.0
 */
import { faker } from '@faker-js/faker';

import { HttpResponse, delay, http } from 'msw';

import { createFrontOfficeInstance } from '../../api-instance';
import type { BodyType } from '../../api-instance';
export interface GetCompanyChannelsResponse {
  /** Total number of channels */
  count: number;
  channels: ChannelReference[];
}

export interface Company {
  id: string;
  /** @maxLength 255 */
  name: string;
  owner_id: string;
}

export interface CompanyCreate {
  /** @maxLength 255 */
  name: string;
}

export interface CompanyUpdate {
  /** @maxLength 255 */
  name: string;
}

export interface CompanyUser {
  company_id: string;
  email: string;
}

export interface CompanyChannel {
  company_id: string;
  channel_id: string;
}

export interface ChannelUser {
  user_id: string;
  channel_id: string;
}

export interface UserReference {
  id: string;
  is_active: boolean;
  role: string;
  first_name: string;
  last_name: string;
  email?: string;
}

export interface ChannelReference {
  /** ID канала */
  id: string;
  /** ID владельца канала */
  owner_id: string;
  protocol: Protocol;
  status: ChannelStatus;
  /** Канал активен */
  is_active: boolean;
  name: string;
  phone_number: string;
}

/**
 * Протокол
 */
export type Protocol = (typeof Protocol)[keyof typeof Protocol];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Protocol = {
  telegram_personal: 'telegram_personal',
  telegram_bot: 'telegram_bot',
  whatsapp_gray: 'whatsapp_gray',
  infobip: 'infobip',
  vk: 'vk',
} as const;

/**
 * Статус канала коммуникации
 */
export type ChannelStatus = (typeof ChannelStatus)[keyof typeof ChannelStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChannelStatus = {
  unauthorized: 'unauthorized',
  pending_payment: 'pending_payment',
  qr_in_progress: 'qr_in_progress',
  password_required: 'password_required',
  required_scan_qr: 'required_scan_qr',
  authorized: 'authorized',
  contacts_synced: 'contacts_synced',
  chats_synced: 'chats_synced',
  ready: 'ready',
} as const;

export interface ProblemDetails {
  /** Подробное описание ошибки */
  detail: string;
  /** Краткое описание проблемы */
  code: string;
}

export type TransferChannelToNewCompanyParams = {
  new_company_id: string;
};

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Get list of companies
 */
export const getCompaniesList = (
  options?: SecondParameter<typeof createFrontOfficeInstance>
) => {
  return createFrontOfficeInstance<Company[]>(
    { url: `/api/v1/companies`, method: 'GET' },
    options
  );
};

/**
 * @summary Create a new company
 */
export const createCompany = (
  companyCreate: BodyType<CompanyCreate>,
  options?: SecondParameter<typeof createFrontOfficeInstance>
) => {
  return createFrontOfficeInstance<Company>(
    {
      url: `/api/v1/companies/create`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: companyCreate,
    },
    options
  );
};

/**
 * @summary Get company by ID
 */
export const getCompanyById = (
  companyId: string,
  options?: SecondParameter<typeof createFrontOfficeInstance>
) => {
  return createFrontOfficeInstance<Company>(
    { url: `/api/v1/companies/${companyId}`, method: 'GET' },
    options
  );
};

/**
 * @summary Update company
 */
export const updateCompanyById = (
  companyId: string,
  companyUpdate: BodyType<CompanyUpdate>,
  options?: SecondParameter<typeof createFrontOfficeInstance>
) => {
  return createFrontOfficeInstance<Company>(
    {
      url: `/api/v1/companies/${companyId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: companyUpdate,
    },
    options
  );
};

/**
 * @summary Delete company
 */
export const deleteCompany = (
  companyId: string,
  options?: SecondParameter<typeof createFrontOfficeInstance>
) => {
  return createFrontOfficeInstance<void>(
    { url: `/api/v1/companies/${companyId}`, method: 'DELETE' },
    options
  );
};

/**
 * @summary Get users of company
 */
export const getCompanyUsers = (
  companyId: string,
  options?: SecondParameter<typeof createFrontOfficeInstance>
) => {
  return createFrontOfficeInstance<UserReference[]>(
    { url: `/api/v1/companies/${companyId}/users/`, method: 'GET' },
    options
  );
};

/**
 * @summary Add user to company
 */
export const addUserToCompany = (
  companyId: string,
  email: string,
  options?: SecondParameter<typeof createFrontOfficeInstance>
) => {
  return createFrontOfficeInstance<CompanyUser>(
    { url: `/api/v1/companies/${companyId}/users/${email}`, method: 'POST' },
    options
  );
};

/**
 * @summary Remove user from company
 */
export const deleteUserFromCompany = (
  companyId: string,
  email: string,
  options?: SecondParameter<typeof createFrontOfficeInstance>
) => {
  return createFrontOfficeInstance<void>(
    { url: `/api/v1/companies/${companyId}/users/${email}`, method: 'DELETE' },
    options
  );
};

/**
 * @summary Get channels of company
 */
export const getCompanyChannels = (
  companyId: string,
  options?: SecondParameter<typeof createFrontOfficeInstance>
) => {
  return createFrontOfficeInstance<GetCompanyChannelsResponse>(
    { url: `/api/v1/companies/${companyId}/channels/`, method: 'GET' },
    options
  );
};

/**
 * @summary Add channel to company
 */
export const addChannelToCompany = (
  companyId: string,
  channelId: string,
  options?: SecondParameter<typeof createFrontOfficeInstance>
) => {
  return createFrontOfficeInstance<CompanyChannel>(
    {
      url: `/api/v1/companies/${companyId}/channels/${channelId}`,
      method: 'POST',
    },
    options
  );
};

/**
 * @summary Remove channel from company and move to new company
 */
export const transferChannelToNewCompany = (
  companyId: string,
  channelId: string,
  params: TransferChannelToNewCompanyParams,
  options?: SecondParameter<typeof createFrontOfficeInstance>
) => {
  return createFrontOfficeInstance<void>(
    {
      url: `/api/v1/companies/${companyId}/channels/${channelId}`,
      method: 'PUT',
      params,
    },
    options
  );
};

/**
 * @summary Remove channel from company
 */
export const deleteChannelFromCompany = (
  companyId: string,
  channelId: string,
  options?: SecondParameter<typeof createFrontOfficeInstance>
) => {
  return createFrontOfficeInstance<void>(
    {
      url: `/api/v1/companies/${companyId}/channels/${channelId}`,
      method: 'DELETE',
    },
    options
  );
};

/**
 * @summary Add user to channel in company
 */
export const addUserToChannel = (
  companyId: string,
  channelId: string,
  userId: string,
  options?: SecondParameter<typeof createFrontOfficeInstance>
) => {
  return createFrontOfficeInstance<ChannelUser>(
    {
      url: `/api/v1/companies/${companyId}/channel/${channelId}/user/${userId}`,
      method: 'POST',
    },
    options
  );
};

export type GetCompaniesListResult = NonNullable<
  Awaited<ReturnType<typeof getCompaniesList>>
>;
export type CreateCompanyResult = NonNullable<
  Awaited<ReturnType<typeof createCompany>>
>;
export type GetCompanyByIdResult = NonNullable<
  Awaited<ReturnType<typeof getCompanyById>>
>;
export type UpdateCompanyByIdResult = NonNullable<
  Awaited<ReturnType<typeof updateCompanyById>>
>;
export type DeleteCompanyResult = NonNullable<
  Awaited<ReturnType<typeof deleteCompany>>
>;
export type GetCompanyUsersResult = NonNullable<
  Awaited<ReturnType<typeof getCompanyUsers>>
>;
export type AddUserToCompanyResult = NonNullable<
  Awaited<ReturnType<typeof addUserToCompany>>
>;
export type DeleteUserFromCompanyResult = NonNullable<
  Awaited<ReturnType<typeof deleteUserFromCompany>>
>;
export type GetCompanyChannelsResult = NonNullable<
  Awaited<ReturnType<typeof getCompanyChannels>>
>;
export type AddChannelToCompanyResult = NonNullable<
  Awaited<ReturnType<typeof addChannelToCompany>>
>;
export type TransferChannelToNewCompanyResult = NonNullable<
  Awaited<ReturnType<typeof transferChannelToNewCompany>>
>;
export type DeleteChannelFromCompanyResult = NonNullable<
  Awaited<ReturnType<typeof deleteChannelFromCompany>>
>;
export type AddUserToChannelResult = NonNullable<
  Awaited<ReturnType<typeof addUserToChannel>>
>;

export const getGetCompaniesListResponseMock = (): Company[] =>
  Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1
  ).map(() => ({
    id: faker.string.uuid(),
    name: faker.string.alpha(20),
    owner_id: faker.string.uuid(),
  }));

export const getCreateCompanyResponseMock = (
  overrideResponse: Partial<Company> = {}
): Company => ({
  id: faker.string.uuid(),
  name: faker.string.alpha(20),
  owner_id: faker.string.uuid(),
  ...overrideResponse,
});

export const getGetCompanyByIdResponseMock = (
  overrideResponse: Partial<Company> = {}
): Company => ({
  id: faker.string.uuid(),
  name: faker.string.alpha(20),
  owner_id: faker.string.uuid(),
  ...overrideResponse,
});

export const getUpdateCompanyByIdResponseMock = (
  overrideResponse: Partial<Company> = {}
): Company => ({
  id: faker.string.uuid(),
  name: faker.string.alpha(20),
  owner_id: faker.string.uuid(),
  ...overrideResponse,
});

export const getGetCompanyUsersResponseMock = (): UserReference[] =>
  Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1
  ).map(() => ({
    id: faker.string.uuid(),
    is_active: faker.datatype.boolean(),
    role: faker.string.alpha(20),
    first_name: faker.string.alpha(20),
    last_name: faker.string.alpha(20),
    email: faker.helpers.arrayElement([faker.string.alpha(20), undefined]),
  }));

export const getAddUserToCompanyResponseMock = (
  overrideResponse: Partial<CompanyUser> = {}
): CompanyUser => ({
  company_id: faker.string.uuid(),
  email: faker.string.alpha(20),
  ...overrideResponse,
});

export const getGetCompanyChannelsResponseMock = (
  overrideResponse: Partial<GetCompanyChannelsResponse> = {}
): GetCompanyChannelsResponse => ({
  count: faker.number.int({ min: undefined, max: undefined }),
  channels: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1
  ).map(() => ({
    id: faker.string.uuid(),
    owner_id: faker.string.uuid(),
    protocol: faker.helpers.arrayElement(Object.values(Protocol)),
    status: faker.helpers.arrayElement(Object.values(ChannelStatus)),
    is_active: faker.datatype.boolean(),
    name: faker.string.alpha(20),
    phone_number: faker.string.alpha(20),
  })),
  ...overrideResponse,
});

export const getAddChannelToCompanyResponseMock = (
  overrideResponse: Partial<CompanyChannel> = {}
): CompanyChannel => ({
  company_id: faker.string.uuid(),
  channel_id: faker.string.uuid(),
  ...overrideResponse,
});

export const getAddUserToChannelResponseMock = (
  overrideResponse: Partial<ChannelUser> = {}
): ChannelUser => ({
  user_id: faker.string.uuid(),
  channel_id: faker.string.uuid(),
  ...overrideResponse,
});

export const getGetCompaniesListMockHandler = (
  overrideResponse?:
    | Company[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<Company[]> | Company[])
) => {
  return http.get('*/api/v1/companies', async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getGetCompaniesListResponseMock()
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } }
    );
  });
};

export const getCreateCompanyMockHandler = (
  overrideResponse?:
    | Company
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<Company> | Company)
) => {
  return http.post('*/api/v1/companies/create', async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getCreateCompanyResponseMock()
      ),
      { status: 201, headers: { 'Content-Type': 'application/json' } }
    );
  });
};

export const getGetCompanyByIdMockHandler = (
  overrideResponse?:
    | Company
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<Company> | Company)
) => {
  return http.get('*/api/v1/companies/:companyId', async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getGetCompanyByIdResponseMock()
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } }
    );
  });
};

export const getUpdateCompanyByIdMockHandler = (
  overrideResponse?:
    | Company
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0]
      ) => Promise<Company> | Company)
) => {
  return http.put('*/api/v1/companies/:companyId', async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getUpdateCompanyByIdResponseMock()
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } }
    );
  });
};

export const getDeleteCompanyMockHandler = (
  overrideResponse?:
    | void
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0]
      ) => Promise<void> | void)
) => {
  return http.delete('*/api/v1/companies/:companyId', async (info) => {
    await delay(1000);
    if (typeof overrideResponse === 'function') {
      await overrideResponse(info);
    }
    return new HttpResponse(null, { status: 204 });
  });
};

export const getGetCompanyUsersMockHandler = (
  overrideResponse?:
    | UserReference[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<UserReference[]> | UserReference[])
) => {
  return http.get('*/api/v1/companies/:companyId/users/', async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getGetCompanyUsersResponseMock()
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } }
    );
  });
};

export const getAddUserToCompanyMockHandler = (
  overrideResponse?:
    | CompanyUser
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<CompanyUser> | CompanyUser)
) => {
  return http.post(
    '*/api/v1/companies/:companyId/users/:email',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getAddUserToCompanyResponseMock()
        ),
        { status: 201, headers: { 'Content-Type': 'application/json' } }
      );
    }
  );
};

export const getDeleteUserFromCompanyMockHandler = (
  overrideResponse?:
    | void
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0]
      ) => Promise<void> | void)
) => {
  return http.delete(
    '*/api/v1/companies/:companyId/users/:email',
    async (info) => {
      await delay(1000);
      if (typeof overrideResponse === 'function') {
        await overrideResponse(info);
      }
      return new HttpResponse(null, { status: 204 });
    }
  );
};

export const getGetCompanyChannelsMockHandler = (
  overrideResponse?:
    | GetCompanyChannelsResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<GetCompanyChannelsResponse> | GetCompanyChannelsResponse)
) => {
  return http.get('*/api/v1/companies/:companyId/channels/', async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getGetCompanyChannelsResponseMock()
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } }
    );
  });
};

export const getAddChannelToCompanyMockHandler = (
  overrideResponse?:
    | CompanyChannel
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<CompanyChannel> | CompanyChannel)
) => {
  return http.post(
    '*/api/v1/companies/:companyId/channels/:channelId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getAddChannelToCompanyResponseMock()
        ),
        { status: 201, headers: { 'Content-Type': 'application/json' } }
      );
    }
  );
};

export const getTransferChannelToNewCompanyMockHandler = (
  overrideResponse?:
    | void
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0]
      ) => Promise<void> | void)
) => {
  return http.put(
    '*/api/v1/companies/:companyId/channels/:channelId',
    async (info) => {
      await delay(1000);
      if (typeof overrideResponse === 'function') {
        await overrideResponse(info);
      }
      return new HttpResponse(null, { status: 204 });
    }
  );
};

export const getDeleteChannelFromCompanyMockHandler = (
  overrideResponse?:
    | void
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0]
      ) => Promise<void> | void)
) => {
  return http.delete(
    '*/api/v1/companies/:companyId/channels/:channelId',
    async (info) => {
      await delay(1000);
      if (typeof overrideResponse === 'function') {
        await overrideResponse(info);
      }
      return new HttpResponse(null, { status: 204 });
    }
  );
};

export const getAddUserToChannelMockHandler = (
  overrideResponse?:
    | ChannelUser
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<ChannelUser> | ChannelUser)
) => {
  return http.post(
    '*/api/v1/companies/:companyId/channel/:channelId/user/:userId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getAddUserToChannelResponseMock()
        ),
        { status: 201, headers: { 'Content-Type': 'application/json' } }
      );
    }
  );
};
export const getCompanyManagementAPIMock = () => [
  getGetCompaniesListMockHandler(),
  getCreateCompanyMockHandler(),
  getGetCompanyByIdMockHandler(),
  getUpdateCompanyByIdMockHandler(),
  getDeleteCompanyMockHandler(),
  getGetCompanyUsersMockHandler(),
  getAddUserToCompanyMockHandler(),
  getDeleteUserFromCompanyMockHandler(),
  getGetCompanyChannelsMockHandler(),
  getAddChannelToCompanyMockHandler(),
  getTransferChannelToNewCompanyMockHandler(),
  getDeleteChannelFromCompanyMockHandler(),
  getAddUserToChannelMockHandler(),
];
